import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import {
  Col, Tabs,
} from 'antd';
import { PropType as PolygotPropType } from 'redux-polyglot';
import momentPropTypes from 'react-moment-proptypes';
import ChartCard from 'components/ChartCard';
import Bar from './Bar';
import GeneralSelect from '../../../../GeneralSelect';

const { TabPane } = Tabs;

class ArrivalDeparture extends Component {
  constructor(props) {
    super(props);
    const { p } = this.props;
    this.tabs = [p.tt('enplanement.tabs.gate'), p.tt('enplanement.tabs.airline')];
    this.state = {
      activeTab: this.tabs[0],
      showTabs: false,
      itemsArray: [],
      selectedItem: '',
    };
  }

  @autobind
  handleItemChange(item) {
    this.setState({ selectedItem: item });
  }

  @autobind
  handleUpdateItems(items) {
    this.setState({ itemsArray: items });
  }

  @autobind
  handleTabChange(key) {
    this.setState({ activeTab: key });
  }

  render() {
    const {
      p, startDate, endDate, locationId, gates, title,
    } = this.props;
    const {
      activeTab, showTabs, itemsArray, selectedItem,
    } = this.state;
    return (

      <div className="vehicle-half-card">
        <div className="header no-margin-header" style={{ position: 'relative' }}>
          <h2 className="title">{title}</h2>
          {
            showTabs
            && (
            <Tabs
              activeKey={activeTab}
              style={{ position: 'absolute', bottom: 0, right: 20 }}
              onChange={this.handleTabChange}
            >
              <TabPane tab={this.tabs[0]} key={this.tabs[0]} />
              <TabPane tab={this.tabs[1]} key={this.tabs[1]} />
            </Tabs>
            )
          }

        </div>
        <div className="vehicle-half-card-body">
          <Col span={24}>
            <div style={{
              padding: '30px 30px 0 20px', display: 'flex', justifyContent: 'end', width: '100%',
            }}
            >
              <GeneralSelect
                p={p}
                name={activeTab}
                items={itemsArray}
                onChange={this.handleItemChange}
                selected={selectedItem}
              />
            </div>
            <ChartCard
              title=""
              hideInfo
              initialDimension="hour"
              hideIcon
              showMin
            >
              <Bar
                p={p}
                locationId={locationId}
                startDate={startDate}
                endDate={endDate}
                gates={gates}
                handleUpdateItems={this.handleUpdateItems}
                handleItemChange={this.handleItemChange}
                selectedItem={selectedItem}
              />
            </ChartCard>
          </Col>
        </div>
      </div>
    );
  }
}

ArrivalDeparture.propTypes = {
  p: PolygotPropType,
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
  locationId: PropTypes.number,
  gates: PropTypes.object,
  title: PropTypes.string,
};

export default ArrivalDeparture;
